import { For, Show, createMemo } from "solid-js";

import { Trans } from "@lingui/solid/macro";
import { ServerMember } from "stoat.js";
import { styled } from "styled-system/jsx";

import { useModals } from "@revolt/modal";

import { Ripple, Text, typography } from "../../design";

import { ProfileCard } from "./ProfileCard";

export function ProfileRoles(props: { member?: ServerMember }) {
  const { openModal } = useModals();

  const visibleRoles = createMemo(() =>
    props.member
      ? props.member.orderedRoles.filter((r) =>
          props.member?.server ? props.member.server.roles.has(r.id) : true,
        )
      : [],
  );

  function openRoles() {
    openModal({ type: "user_profile_roles", member: props.member! });
  }

  return (
    <Show when={visibleRoles().length}>
      <ProfileCard isLink onClick={openRoles}>
        <Ripple />

        <Text class="title" size="large">
          <Trans>Roles</Trans>
        </Text>
        <div use:invisibleScrollable>
          <Chips>
            <For each={visibleRoles().toReversed()}>
              {(role) => (
                <Chip>
                  <RoleIcon
                    style={{
                      background:
                        role.colour ?? "var(--md-sys-color-outline-variant)",
                    }}
                  />
                  <span>{role.name}</span>
                </Chip>
              )}
            </For>
          </Chips>
        </div>
      </ProfileCard>
    </Show>
  );
}

const Chips = styled("div", {
  base: {
    display: "flex",
    flexWrap: "wrap",
    gap: "6px",
  },
});

const Chip = styled("div", {
  base: {
    display: "inline-flex",
    alignItems: "center",
    gap: "6px",
    maxWidth: "100%",
    padding: "3px 10px",
    borderRadius: "999px",
    background: "var(--md-sys-color-surface-container-highest)",
    border: "1px solid var(--md-sys-color-outline-variant)",
    ...typography.raw({ class: "label" }),
    "& > span": {
      overflow: "hidden",
      whiteSpace: "nowrap",
      textOverflow: "ellipsis",
    },
  },
});

const RoleIcon = styled("div", {
  base: {
    flexShrink: 0,
    width: "10px",
    height: "10px",
    aspectRatio: "1/1",
    borderRadius: "100%",
  },
});
